import { For } from '../c-mp/comp/For'
import { $when, Show } from '../c-mp/comp/Show'
import { Slot } from '../c-mp/comp/Slot'
import { defineComponent } from '../c-mp/fun/defineComponent'
import { url } from '../c-mp/fun/url'
import { expectDefined } from '../fun/expectDefined'
import { formatNumber } from '../fun/formatNumber'
import { getDataOrThrow } from '../fun/getDataOrThrow'
import { setPageTitle } from '../fun/setPageTitle'
import { _ } from '../model/ccc'
import { PersonLinkComp } from './PersonLinkComp'

const PERSON_LIMIT = 10

export const PageCloudsComp = defineComponent<{}>(
	'PageCloudsComp',
	(props, $) => {
		setPageTitle('Felhők')

		const data = getDataOrThrow()

		return (
			<div class={_.ccc_page}>
				<h1>Felhők</h1>
				<div class={_.ccc_narrow}>
					<p>
						Az adatok között megtalálható emberek azonos felhőbe tartoznak, ha
						köztük egyértelműen földeríthető valamilyen rokoni kapcsolat.
					</p>
					<p>
						Alább a felhők <b>legifjabb</b> tagjait listázzuk.
					</p>
				</div>
				<div class={_.ccc_clouds}>
					<For
						debugName='Felhők'
						each={() => data.clouds}
						render={({ get: getCloud }) => (
							<div class={_.ccc_cloud}>
								<p>
									<b>
										<Slot get={() => getCloud().id + ''} />. felhő
									</b>
									:{' '}
									<Slot get={() => formatNumber(getCloud().personIds.length)} />{' '}
									fő
								</p>
								<div class={_.ccc_tiles__centered}>
									<For
										debugName='Felhő népe'
										each={() =>
											getCloud()
												.personIds.map((id) =>
													expectDefined(data.personsById[id]),
												)
												.sort((a, b) =>
													(b.birthDate ?? '0000').localeCompare(
														a.birthDate ?? '0000',
													),
												)
												.slice(
													0,
													getCloud().personIds.length === PERSON_LIMIT + 1
														? PERSON_LIMIT + 1
														: PERSON_LIMIT,
												)
										}
										render={PersonLinkComp}
									/>
									<Show
										it={$when(
											() => getCloud().personIds.length > PERSON_LIMIT + 1,
											() => (
												<a
													class={_.ccc_button__plus}
													href={() =>
														url`/search?query=${`{${getCloud().id}}`}`
													}
												>
													...a felhő mind a{' '}
													<Slot
														get={() =>
															formatNumber(getCloud().personIds.length)
														}
													/>{' '}
													tagja
												</a>
											),
										)}
									/>
								</div>
							</div>
						)}
					/>
				</div>
			</div>
		)
	},
)
